export const getUseSchoolYear = () => {
  // Default should be "on" and you need to explicitly turn it off
  return process.env?.REACT_APP_USE_SCHOOL_YEAR?.trim().toLowerCase() !== 'false'
}
